import Autoscroll from 'embla-carousel-auto-scroll';

import { type ProductVariantCardFragment } from '@boc/framework/saleor-graphql';

import { Carousel, CarouselContent, CarouselItem } from '~/local/homepage/components/slider';
import VariantCompactCard from '~/local/products/components/variant-compact-card';

export const ProductCarousel = ({
  heading,
  variants,
}: {
  heading: React.ReactNode;
  variants: ProductVariantCardFragment[];
}) => {
  return (
    <div className="flex flex-col">
      <h3 className="font-heading-condensed text-primary-2-80 text-center text-3xl font-medium tracking-tight sm:text-6xl">
        {heading}
      </h3>

      <div className="bg-gradient-to-b from-primary-2-10 to-[#E5E1FE] pb-8 pt-14">
        <Carousel
          opts={{
            loop: true,
          }}
          plugins={[Autoscroll({})]}
        >
          <CarouselContent>
            {variants.map((variant, index) => (
              <CarouselItem key={index} className="basis-36 hover:-translate-y-6">
                <VariantCompactCard variant={variant} />
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </div>
    </div>
  );
};
